// @flow
import React, { Node } from 'react';
import Tooltip from '../../../../components/Tooltip';

type Props = {
    children: Node,
    title: string,
    tooltipContent?: Node,
    gridArea: string,
    hideTooltip?: boolean,
}

function MallMarketingTile(props: Props) {
  return (
    <div className="mall-marketing-tile">
      <div className="mall-marketing-tile-title-container">
        <h2 className="mall-marketing-tile-title">
          {props.title}
        </h2>
        {
          !props.hideTooltip
          && (
            <Tooltip>
              {props.tooltipContent}
            </Tooltip>
          )
        }
      </div>
      <div className="content">
        {props.children}
      </div>
    </div>
  );
}

export default MallMarketingTile;
